<template>
	<nav class="absolute w-full top-0 z-30">
		<div
			class="container mx-auto px-4 lg:w-3/4 flex justify-between items-center py-4"
		>
			<div
				class="text-sm bg-white bg-opacity-50 text-gray-900 py-2 px-4 rounded-md dark:bg-gray-600 dark:text-gray-200"
			>
				Icons By
				<a href="https://www.baianat.com/" class="underline">Baianat</a> •
				Developed By
				<a href="http://bargush.me" class="underline">Abdulaziz Bargush</a>
			</div>
			<button
				class="p-2 bg-white bg-opacity-50 rounded-md focus:outline-none dark:bg-gray-600 ml-4"
				@click="switchTheme"
			>
				<i class="theme-switcher"></i>
			</button>
		</div>
	</nav>
</template>

<script>
export default {
	data() {
		return {
			theme: "light",
		};
	},
	mounted() {
		if (
			localStorage.theme === "dark" ||
			(!("theme" in localStorage) &&
				window.matchMedia("(prefers-color-scheme: dark)").matches)
		) {
			this.goDark();
		} else {
			this.goLight();
		}
	},
	methods: {
		switchTheme() {
			if (this.theme === "light") {
				this.goDark();
			} else {
				this.goLight();
			}
		},
		goLight() {
			localStorage.theme = "light";
			document.documentElement.classList.remove("dark");
			this.theme = "light";
		},
		goDark() {
			localStorage.theme = "dark";
			document.documentElement.classList.add("dark");
			this.theme = "dark";
		},
	},
};
</script>

<style lang="scss" scoped>
.theme-switcher {
	@apply relative block h-4 w-4;

	&::before {
		content: "";
		@apply block absolute right-0 h-4 w-2 rounded-r-full bg-gray-900 dark:bg-gray-200;
	}
	&::after {
		content: "";
		@apply block absolute left-0 h-4 w-2 rounded-l-full border-2 border-gray-900 dark:border-gray-200;
		border-right-color: transparent !important;
	}
}
</style>
